// Batch 2: Giza, 6th of October & Sheikh Zayed (33 Areas)
export const areaContentBatch2 = {
  "الدقي": {
    tier: 1,
    title: "ونش انقاذ الدقي",
    metaDescription: "ونش انقاذ الدقي: ميدان الدقي، شارع التحرير، شارع مصدق، محيي الدين أبو العز، كوبري 6 أكتوبر، كوبري الدقي. سطحة سريعة تصلك في 7-10 دقائق 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "خدمة ونش إنقاذ سريعة وفورية في حي الدقي تغطي ميدان الدقي، شارع مصدق، محيي الدين أبو العز، ميدان المساحة، محيط وزارة الزراعة، ومطالع ومنازل كوبري 6 أكتوبر وكوبري الدقي؛ أوناش مجهزة للتدخل في غضون 7 إلى 10 دقائق فقط بأفضل الأسعار.",
    responseTime: "7–10 دقائق في الدقي",
    dispatchPoints: [
      "ميدان الدقي ومطلع ومنزل كوبري 6 أكتوبر (الاستجابة: 5–7 دقائق)",
      "شارع مصدق ومحيط محيي الدين أبو العز (الاستجابة: 7–9 دقائق)",
      "ميدان المساحة والسفارات وشارع إيران (الاستجابة: 7–9 دقائق)",
      "كوبري الجامعة وشارع التحرير ومحيط حديقة الأورمان (الاستجابة: 8–10 دقائق)"
    ],
    landmarks: [
      "ميدان الدقي ومحطة مترو الدقي",
      "ميدان المساحة وفندق سفير",
      "شارع مصدق التجاري",
      "شارع محيي الدين أبو العز",
      "مستشفى مصر الدولي ومستشفى الدقي التخصصي",
      "متحف الزراعة المصرية ونادي الصيد (فرع الدقي)",
      "كوبري الدقي المعدني ومطلع كوبري 6 أكتوبر",
      "كوبري الجامعة ومحيط كلية العلاج الطبيعي",
      "شارع التحرير والمركز الثقافي الروسي"
    ],
    streets: [
      "شارع التحرير (الدقي)",
      "شارع مصدق",
      "شارع الدقي الرئيسي",
      "شارع محيي الدين أبو العز",
      "شارع لطفي حسونة",
      "شارع إيران",
      "شارع السودان ومطلع صفط اللبن",
      "شارع وزارة الزراعة",
      "شارع السد العالي"
    ],
    localNotes: [
      "إخلاء فوري لحالات الأعطال والحوادث أعلى مطلع ومنزل كوبري الدقي وكوبري 6 أكتوبر لتفادي شلل المحاور الحيوية بين الجيزة والقاهرة.",
      "أوناش شوكة وسطحات هيدروليكية مدمجة تناسب شوارع الدقي السكنية ومحيط السفارات والشركات الكبرى دون إعاقة المرور.",
      "سرعة نقل السيارة لمراكز الصيانة المعتمدة بالدقي والمهندسين أو مجمعات الورش بالجيزة وباب اللوق.",
      "تجهيزات متكاملة للمساعدة على الطريق (شحن بطاريات، تغيير إطارات، توصيل وقود) في موقعك بالدقي."
    ],
    faqs: [
      {
        "q": "كم يستغرق ونش الإنقاذ للوصول إلى ميدان الدقي أو شارع مصدق؟",
        "a": "يصلك الونش في أقل من 7 إلى 10 دقائق لتمركز أوناشنا المباشر أسفل كوبري الدقي وبمحيط شارع التحرير."
      },
      {
        "q": "ما هو الإجراء السريع لو تعطلت السيارة أعلى كوبري 6 أكتوبر أو كوبري الدقي؟",
        "a": "شغل أضواء الانتظار (الفلاشر) وقف أقصى اليمين، واتصل بنا على 01044844492 لنتحرك فوراً بأقرب ونش لتأمين سيارتك وسحبها خلال دقائق."
      },
      {
        "q": "هل يتوفر ونش لنقل السيارات من الدقي إلى مراكز الصيانة بالمهندسين أو الجيزة؟",
        "a": "نعم، نوفر خدمة نقل سريعة لمراكز الصيانة والتوكيلات في المهندسين، العجوزة، شارع فيصل، وأي منطقة تختارها."
      },
      {
        "q": "هل تقدمون خدمات شحن البطارية وتغيير العجل في شوارع الدقي؟",
        "a": "نعم، خدمات المساعدة على الطريق متوفرة فوراً في موقعك دون الحاجة لسحب السيارة إذا كان العطل بسيطاً."
      },
      {
        "q": "هل أسعار خدمة ونش إنقاذ الدقي محددة مسبقاً؟",
        "a": "نعم، نحدد معك التكلفة التقديرية بدقة هاتفياً قبل تحرك الونش مع تطبيق خصم 50% المعلن وبدون أي رسوم خفية."
      }
    ],
    nearby: ["المهندسين", "العجوزة", "شارع التحرير", "مصدق", "الجيزة", "وسط البلد"]
  },

  "المهندسين": {
    tier: 1,
    title: "ونش انقاذ المهندسين",
    metaDescription: "ونش انقاذ المهندسين: جامعة الدول العربية، شارع البطل أحمد عبد العزيز، ميدان لبنان، شارع سوريا، شهاب. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ راقية في المهندسين تغطي شارع جامعة الدول العربية، البطل أحمد عبد العزيز، ميدان سفنكس، وشارع السودان بسطحات هيدروليكية في 10 دقائق.",
    responseTime: "10 دقائق في المهندسين",
    landmarks: ["ميدان مصطفى محمود", "ميدان لبنان", "نادي الصيد المصري بالدقي/المهندسين", "ميدان الثورة", "مستشفى الشروق", "مول بلاتينيوم"],
    streets: ["شارع جامعة الدول العربية", "شارع البطل أحمد عبد العزيز", "شارع سوريا", "شارع شهاب", "شارع وادي النيل", "شارع أحمد عرابي", "شارع السودان"],
    localNotes: ["أوناش سطحة هيدروليكية كاملة مخصصة لحماية السيارات الفارهة والمنخفضة المنتشرة بحي المهندسين التجاري.", "التعامل الاحترافي مع ركنات الصف الثاني والشوارع المزدحمة بمحيط شوارع شهاب وسوريا وجامعة الدول.", "تأمين سريع للسيارات لتفادي تعطيل حركة السير بمحيط محطات المترو الجديدة وشارع السودان."],
    faqs: [
      {
            "q": "هل يصل الونش لشارع جامعة الدول أو ميدان لبنان وقت الزحام؟",
            "a": "نعم، نصلك في غضون 10 دقائق لاعتمادنا على أوناش متمركزة في شوارع بديلة ومحاور سريعة تلتف حول الزحام."
      },
      {
            "q": "هل يتوفر لديكم سطحة هيدروليك للسيارات المنخفضة بالمهندسين؟",
            "a": "نعم، كافة أوناشنا بالمهندسين سطحات هيدروليكية كاملة بزاوية صفرية تلامس الأرض لحماية الصدادات."
      }
],
    nearby: ["الدقي", "العجوزة", "ميدان لبنان", "جامعة الدول العربية", "شارع وادي النيل", "أرض اللواء"]
  },

  "العجوزة": {
    tier: 2,
    title: "ونش انقاذ العجوزة",
    metaDescription: "ونش انقاذ العجوزة: كورنيش النيل، ميدان سفنكس، مستشفى العجوزة، مسرح البالون، شارع النيل. وصول 10 دقائق خدمة 24/7 - 01044844492.",
    intro: "ونش إنقاذ العجوزة وشاطئ النيل ومحيط كوبري 15 مايو ومستشفى العجوزة وميدان شاهين؛ وصول فوري خلال 8 إلى 10 دقائق لإنقاذ وسحب سيارتك بأمان.",
    responseTime: "8–10 دقائق في العجوزة",
    landmarks: ["مستشفى العجوزة النموذجي", "مستشفى الشرطة بالعجوزة", "مسرح البالون والسيرك القومي", "ميدان سفنكس", "فندق شيراتون القاهرة"],
    streets: ["شارع النيل (كورنيش العجوزة)", "شارع عبد المنعم رياض", "شارع الفالوجا", "شارع شاهين", "شارع أحمد عرابي (مدخل العجوزة)"],
    localNotes: ["تمركز مباشر على كورنيش العجوزة ومحيط مسرح البالون لسرعة نجدة السيارات على كورنيش النيل.", "أوناش سحب مدمجة تناسب الشوارع السكنية الهادئة بالعجوزة دون إحداث أي ضوضاء أو تعطيل.", "قرب المسافة لنقل السيارة لمراكز الخدمة والورش بالمهندسين والدقي وإمبابة."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش على كورنيش النيل بالعجوزة؟",
            "a": "يصلك الونش في أقل من 8 دقائق لتواجد سيارة إنقاذ دائمة بالقرب من كوبري 15 مايو وكورنيش العجوزة."
      },
      {
            "q": "هل تنقذون سيارات الحوادث على مطلع كوبري أكتوبر من العجوزة؟",
            "a": "نعم، طاقمنا مدرب على سرعة رفع وسحب سيارات الحوادث وتأمين الطريق فوراً."
      }
],
    nearby: ["المهندسين", "الدقي", "ميدان سفنكس", "الزمالك", "ميدان لبنان", "كورنيش النيل"]
  },

  "ميدان لبنان": {
    tier: 2,
    title: "ونش انقاذ ميدان لبنان المهندسين",
    metaDescription: "ونش انقاذ ميدان لبنان: مطلع محور 26 يوليو، شارع لبنان، شارع السودان، مخرج المهندسين. وصول 5-10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "ميدان لبنان نقطة التوزيع الرئيسية بين المهندسين ومحور 26 يوليو المتجه لأكتوبر والشيخ زايد. أوناشنا متمركزة بالميدان للتدخل الفوري عند أي عطل أو حادث على مدار الساعة.",
    responseTime: "5–10 دقائق في ميدان لبنان",
    landmarks: ["ميدان لبنان الرئيسي", "مطلع محور 26 يوليو باتجاه أكتوبر", "نزلة كوبري 15 مايو", "مجمع البنوك بميدان لبنان", "محطة ميكروباص ميدان لبنان"],
    streets: ["شارع لبنان", "شارع السودان", "محور 26 يوليو", "شارع مكة المكرمة", "شارع القدس الشريف"],
    localNotes: ["تأمين الحوادث والأعطال السريعة عند مطلع ومنزل محور 26 يوليو بميدان لبنان.", "انطلاق فوري نحو شوارع المهندسين الداخلية أو طريق محور 26 يوليو."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند مطلع محور 26 يوليو بميدان لبنان؟",
            "a": "نعم، أوناشنا متواجدة بصفة دائمة تحت كوبري 15 مايو وميدان لبنان."
      }
,
      {
        "q": "هل تخدمون الشوارع المتفرعة من ميدان لبنان باتجاه الموهندسين والدقي؟",
        "a": "نعم، ميدان لبنان نقطة التقاء لشوارع المهندسين والدقي والعجوزة — أوناشنا تصل من أي اتجاه."
      }],
    nearby: ["المهندسين", "العجوزة", "أرض اللواء", "محور 26 يوليو", "شارع السودان"]
  },

  "جامعة الدول العربية": {
    tier: 2,
    title: "ونش انقاذ شارع جامعة الدول العربية",
    metaDescription: "ونش انقاذ شارع جامعة الدول العربية المهندسين: من ميدان سفنكس حتى شارع السودان. وصول 5-10 دقائق خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "شارع جامعة الدول العربية الشريان الأهم بالمهندسين. نوفر أوناش سطحة هيدروليكية حديثة لخدمة المحلات والمطاعم والشركات ومحطات البنزين على طول الشارع على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في جامعة الدول العربية",
    landmarks: ["ميدان مصطفى محمود", "نادي الترسانة الرياضي", "فندق أطلس الزمالك", "مجمع مطاعم جامعة الدول", "مبنى أسواق الشريف"],
    streets: ["شارع جامعة الدول العربية", "شارع الحجاز المهندسين", "شارع الفواكه", "شارع المشهد السكندري", "شارع محيي الدين أبو العز"],
    localNotes: ["أوناش متخصصة في سحب السيارات ذات القير الأوتوماتيك والسيارات المنخفضة بأمان.", "تأمين سريع للسيارات المتعطلة في الجزيرة الوسطى أو أمام المحلات التجارية."],
    faqs: [
      {
            "q": "هل يمكن للونش سحب سيارة أوتوماتيك معطلة في جامعة الدول؟",
            "a": "نعم، نستخدم سطحات هيدروليكية كاملة ترفع السيارة بالكامل دون جرها على الأرض."
      }
,
      {
        "q": "ما زمن الوصول على شارع جامعة الدول في الزحام؟",
        "a": "نعرف الطرق البديلة في المهندسين والعجوزة — متوسط وصولنا 10-15 دقيقة بدون الاعتماد على الشارع الرئيسي وحده."
      }],
    nearby: ["المهندسين", "الدقي", "ميدان لبنان", "ميدان سفنكس", "شارع وادي النيل"]
  },

  "شارع وادي النيل": {
    tier: 2,
    title: "ونش انقاذ شارع وادي النيل المهندسين",
    metaDescription: "ونش انقاذ شارع وادي النيل: من جامعة الدول حتى مستشفى الشروق وميدان الرماية. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "خدمة ونش إنقاذ متواجدة بشارع وادي النيل بالمهندسين، نغطي الشارع بالكامل والتقاطعات مع شارع جامعة الدول العربية وجزيرة العرب ومحيط المستشفيات والمراكز الطبية.",
    responseTime: "10 دقائق في شارع وادي النيل",
    landmarks: ["مستشفى الشروق", "تقاطع وادي النيل مع جامعة الدول", "ميدان حديقة النيل", "مجمع العيادات التخصصية بوادي النيل"],
    streets: ["شارع وادي النيل", "شارع جزيرة العرب", "شارع عبد المنعم رياض", "شارع شهاب (تقاطع وادي النيل)"],
    localNotes: ["أوناش مدمجة تناسب الحركة في شوارع المهندسين الهادئة ومواقف العيادات.", "توفير خدمات الطوارئ للبطاريات وتغيير الإطارات في الموقع."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ بشارع وادي النيل؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتمركزنا المستمر بالمنطقة."
      }
,
      {
        "q": "ما أصعب تحدي تتعاملون معه على شارع وادي النيل؟",
        "a": "أكثر الحالات صعوبة هي أعطال الجراجات البيزمنت تحت العقارات — ولدينا أوناش صغيرة مجهزة خصيصاً لها."
      }],
    nearby: ["المهندسين", "جامعة الدول العربية", "العجوزة", "ميدان سفنكس", "شارع شهاب"]
  },

  "ميدان سفنكس": {
    tier: 2,
    title: "ونش انقاذ ميدان سفنكس المهندسين والعجوزة",
    metaDescription: "ونش انقاذ ميدان سفنكس: شارع أحمد عرابي، مطلع كوبري 15 مايو، شارع النيل، سينما سفنكس. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان سفنكس مدخل المهندسين والعجوزة من كوبري 15 مايو والزمالك. نوفر أوناش إنقاذ متمركزة بالميدان للوصول السريع لشارع أحمد عرابي وجامعة الدول وكورنيش النيل.",
    responseTime: "5–10 دقائق في ميدان سفنكس",
    landmarks: ["ميدان سفنكس الشهير", "سينما ومسرح سفنكس", "مطلع كوبري 15 مايو", "مول سفنكس التجاري", "مبنى الغرفة التجارية بالجيزة"],
    streets: ["شارع أحمد عرابي", "شارع جامعة الدول العربية", "شارع النيل", "شارع 26 يوليو (العجوزة)", "شارع السكرية"],
    localNotes: ["تأمين فوري للسيارات عند منزل كوبري 15 مايو ومطلع شارع أحمد عرابي.", "سحب آمن وسريع للمركبات ونقلها لأي مركز صيانة بالجيزة أو القاهرة."],
    faqs: [
      {
            "q": "هل ونش الإنقاذ متواجد عند كوبري 15 مايو بميدان سفنكس؟",
            "a": "نعم، أوناشنا متمركزة بجوار كوبري 15 مايو بميدان سفنكس 24/7."
      }
,
      {
        "q": "هل تخدمون شارع جامعة الدول العربية المتفرع من ميدان سفنكس؟",
        "a": "نعم، نغطي شارع جامعة الدول العربية بالكامل من ميدان سفنكس حتى ميدان لبنان."
      }],
    nearby: ["المهندسين", "العجوزة", "جامعة الدول العربية", "الزمالك", "شارع أحمد عرابي"]
  },

  "أرض اللواء": {
    tier: 2,
    title: "ونش انقاذ أرض اللواء",
    metaDescription: "ونش انقاذ أرض اللواء: محور 26 يوليو، مزلقان أرض اللواء، شارع السودان، نزلة الدائري. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ وسحب سيارات سريعة واقتصادية في منطقة أرض اللواء، نغطي محيط محور 26 يوليو وشارع السودان ومزلقان أرض اللواء ونزلة الطريق الدائري بأعلى جاهزية.",
    responseTime: "10–15 دقيقة في أرض اللواء",
    landmarks: ["مزلقان أرض اللواء", "محطة قطار بشتيل الجديدة (بالقرب)", "نزلة الدائري بأرض اللواء", "كوبري المشاة بأرض اللواء"],
    streets: ["شارع السودان", "شارع المعتمدية", "محور 26 يوليو (مسار أرض اللواء)", "شارع ترعة المجنونة", "شارع الصفطاوي"],
    localNotes: ["أوناش مدمجة قادرة على التحرك في الشوارع المزدحمة ومحيط المزلقانات.", "تغطية لحالات الأعطال المفاجئة تحت محور 26 يوليو ومداخل المعتمدية."],
    faqs: [
      {
            "q": "هل يمكن للونش سحب سيارة معطلة بمزلقان أرض اللواء أو شارع السودان؟",
            "a": "نعم، أوناشنا متواجدة على شارع السودان وتصل في دقائق قليلة."
      }
,
      {
        "q": "هل تخدمون الحوادث التي تقع أمام مجمع أرض اللواء والمنطقة الصناعية؟",
        "a": "نعم، نتعامل مع حالات الحوادث والأعطال في محيط أرض اللواء والمنطقة الصناعية والطريق الزراعي."
      }],
    nearby: ["المهندسين", "ميدان لبنان", "شارع السودان", "بولاق الدكرور", "محور 26 يوليو"]
  },

  "الجيزة": {
    tier: 1,
    title: "ونش انقاذ الجيزة",
    metaDescription: "ونش انقاذ الجيزة: ميدان الجيزة، شارع مراد، شارع النيل السياحي، البحر الأعظم، كوبري الجامعة ومحطة قطار الجيزة. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "ونش إنقاذ ميدان الجيزة وشارع مراد والبحر الأعظم ومحيط كوبري عباس؛ أوناش سريعة متمركزة في قلب المحافظة لتصلك في أقل من 10 دقائق على مدار 24 ساعة.",
    responseTime: "10 دقائق في الجيزة",
    landmarks: ["ميدان الجيزة الرئيسي", "جامعة القاهرة وميدان النهضة", "محطة قطار الجيزة", "حديقة الحيوان بالجيزة", "مستشفى أم المصريين العامة"],
    streets: ["شارع مراد", "شارع النيل السياحي", "شارع الجامعة", "شارع ربيع الجيزي", "شارع البحر الأعظم", "ميدان النهضة"],
    localNotes: ["تمركزات حيوية بميدان الجيزة وأول شارع الهرم وشارع البحر الأعظم تضمن وصولاً فورياً في أوقات الذروة.", "أوناش مرنة قادرة على إخلاء نهر الشارع السريع لتفادي التكدس المروري حول مجمع المحاكم ومحطة المترو.", "إمكانية نقل السيارة مباشرة لورش شارع مراد أو مجمعات صيانة الهرم وفيصل والدقي."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش في ميدان الجيزة أو شارع مراد؟",
            "a": "من 8 إلى 10 دقائق لوجود سيارة إنقاذ متمركزة بالقرب من كوبري الجيزة المعدني وشارع الجامعة."
      },
      {
            "q": "هل تنقذون السيارات المعطلة على كورنيش البحر الأعظم؟",
            "a": "نعم، كورنيش البحر الأعظم حتى مدخل الدائري مغطى بالكامل على مدار 24 ساعة."
      }
],
    nearby: ["ميدان الجيزة", "الهرم", "فيصل", "الدقي", "البحر الأعظم", "المنيب"]
  },

  "ميدان الجيزة": {
    tier: 2,
    title: "ونش انقاذ ميدان الجيزة",
    metaDescription: "ونش انقاذ ميدان الجيزة: كوبري الجيزة المعدني، شارع مراد، الأهرام، ربيع الجيزي، محطة مترو الجيزة. وصول 5-10 دقائق - 01044844492.",
    intro: "ميدان الجيزة المركز المروري الأول بالمحافظة. نوفر أوناش إنقاذ متواجدة بالميدان وتحت كوبري الجيزة المعدني للتحرك الفوري نحو شارع الهرم أو فيصل أو مراد أو محطة القطار.",
    responseTime: "5–10 دقائق في ميدان الجيزة",
    landmarks: ["كوبري الجيزة المعدني", "محطة مترو الجيزة", "مجمع محاكم الجيزة", "مستشفى الرمد بالجيزة", "سوق الجيزة التجاري"],
    streets: ["ميدان الجيزة", "شارع مراد", "شارع الأهرام", "شارع ربيع الجيزي", "شارع الجامعة"],
    localNotes: ["أوناش سريعة ومجهزة لرفع وسحب السيارات المتعطلة على كوبري الجيزة المعدني ومطالعه.", "تأمين كامل للموقع وإخلاء فوري للسيارات المعطلة لمنع التكدس."],
    faqs: [
      {
            "q": "هل يتوفر ونش على كوبري الجيزة المعدني؟",
            "a": "نعم، أوناشنا متواجدة عند مطالع ومنازل كوبري الجيزة المعدني 24 ساعة."
      }
,
      {
        "q": "ما هو أسرع طريق لوصول الونش في ميدان الجيزة وقت الزحام؟",
        "a": "نستخدم شارع مراد أو كورنيش النيل حسب الزحام — نصلك في 10-15 دقيقة عبر أقصر مسار متاح."
      }],
    nearby: ["الجيزة", "شارع مراد", "الهرم", "فيصل", "البحر الأعظم", "الدقي"]
  },

  "شارع مراد": {
    tier: 2,
    title: "ونش انقاذ شارع مراد الجيزة",
    metaDescription: "ونش انقاذ شارع مراد الجيزة: من ميدان الجيزة حتى حديقة الحيوان وميدان النهضة والسفارة الفرنسية. وصول 5-10 دقائق - 01044844492.",
    intro: "شارع مراد المحور الهادئ والراقي الرابط بين ميدان الجيزة وميدان النهضة وكورنيش النيل. أوناشنا متواجدة لخدمة الشركات والمستشفيات والسفارات على مدار 24 ساعة.",
    responseTime: "5–10 دقائق في شارع مراد",
    landmarks: ["حديقة الحيوان بالجيزة", "السفارة الفرنسية بالجيزة", "ميدان النهضة وتمثال نهضة مصر", "فندق الفصول الأربعة فور سيزونز الجيزة", "مستشفى العيون الدولي"],
    streets: ["شارع مراد", "شارع الجيزة (شارع النيل)", "شارع شارل ديجول", "شارع النهضة", "شارع ثروت"],
    localNotes: ["أوناش سطحة مجهزة لخدمة نزلاء الفنادق الكبرى والسيارات الدبلوماسية بشارع مراد.", "وصول سريع لكورنيش النيل بالجيزة وكوبري عباس وكوبري الجامعة."],
    faqs: [
      {
            "q": "هل تغطون شارع مراد ومحيط فندق الفور سيزونز بالجيزة؟",
            "a": "نعم، تغطية فورية لشارع مراد وميدان النهضة والفنادق المطلة على النيل."
      }
,
      {
        "q": "هل تخدمون الشوارع الجانبية المتفرعة من شارع مراد؟",
        "a": "نعم، كل الشوارع المتفرعة من مراد في اتجاه الدقي والجيزة والمنيل مغطاة بخدماتنا الكاملة."
      }],
    nearby: ["الجيزة", "ميدان الجيزة", "الدقي", "البحر الأعظم", "المنيل"]
  },

  "شارع التحرير": {
    tier: 2,
    title: "ونش انقاذ شارع التحرير الدقي والجيزة",
    metaDescription: "ونش انقاذ شارع التحرير: من كوبري الجلاء والدقي حتى ميدان الجيزة وكوبري الخشب وبولاق. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "شارع التحرير بالجيزة يمتد من كوبري قصر النيل والجلاء بالدقي حتى صفط اللبن وكوبري الخشب. نوفر أوناش سحب متمركزة على طول الشارع لتلبية نداءات الاستغاثة فوراً.",
    responseTime: "10 دقائق في شارع التحرير",
    landmarks: ["كوبري الجلاء وفندق شيراتون", "محطة مترو الدقي بشارع التحرير", "كوبري الخشب", "تقاطع شارع التحرير مع السودان", "مطلع كوبري صفط اللبن"],
    streets: ["شارع التحرير (قطاع الجيزة والدقي)", "شارع الدقي", "شارع السودان", "شارع محيي الدين أبو العز", "شارع مصدق"],
    localNotes: ["تغطية لكافة التقاطعات الحيوية على شارع التحرير بالدقي ومطلع صفط اللبن.", "خدمات طوارئ فورية لشحن البطاريات وتزويد البنزين على مدار الساعة."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ بشارع التحرير الدقي؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا المستمر على الشارع."
      }
,
      {
        "q": "هل تخدمون شارع التحرير وكوبري أكتوبر عند الزحام الشديد؟",
        "a": "نعم، ولدينا أوناش مخصصة للعمل تحت الكباري وعلى الطرق السريعة بضمانات السلامة الكاملة."
      }],
    nearby: ["الدقي", "المهندسين", "مصدق", "الجيزة", "وسط البلد", "شارع السودان"]
  },

  "مصدق": {
    tier: 2,
    title: "ونش انقاذ شارع مصدق الدقي",
    metaDescription: "ونش انقاذ شارع مصدق الدقي: من شارع السودان ومحي الدين حتى شارع التحرير ومستشفى الشبراويشي. وصول 5-10 دقائق - 01044844492.",
    intro: "شارع مصدق من أشهر الشوارع التجارية والطبية بحي الدقي. أوناش إنقاذ محمد بحر متمركزة لخدمة المحلات والعيادات والشركات ومواقف السيارات طوال 24 ساعة.",
    responseTime: "5–10 دقائق في شارع مصدق",
    landmarks: ["مستشفى الشبراويشي", "تقاطع مصدق مع محيي الدين أبو العز", "مجمع بنوك ومطاعم مصدق", "نادي الصيد (مدخل مصدق)"],
    streets: ["شارع مصدق", "شارع محيي الدين أبو العز", "شارع السودان", "شارع يثرب", "شارع لطفي حسونة"],
    localNotes: ["أوناش مدمجة تتنقل بمرونة في أوقات الذروة بشارع مصدق والشوارع الجانبية.", "توفير خدمات سحب آمن للمركبات المعطلة أمام المستشفيات والمراكز التجارية."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ بشارع مصدق في أوقات الذروة؟",
            "a": "نعم، أوناشنا متواجدة بالدقي وتصل للعميل في شارع مصدق خلال 5 إلى 10 دقائق."
      }
,
      {
        "q": "ما هي الخدمات المتاحة في منطقة مصدق؟",
        "a": "جميع خدمات الإنقاذ متاحة: سحب سيارة، شحن بطارية، تغيير إطار، فتح سيارة. نصلك في 10-15 دقيقة."
      }],
    nearby: ["الدقي", "المهندسين", "شارع التحرير", "جامعة الدول العربية", "شارع وادي النيل"]
  },

  "الهرم": {
    tier: 1,
    title: "ونش انقاذ الهرم",
    metaDescription: "ونش انقاذ الهرم: مشعل، العريش، الطالبية، ترسا، كايرو مول، وميدان الرماية. وصول 10-15 دقيقة خدمة 24 ساعة بخصم 50% - اتصل 01044844492.",
    intro: "ونش إنقاذ شارع الهرم (شارع الأهرام) وترعة المريوطية والمنصورية؛ وصول سريع خلال 10 إلى 15 دقيقة مع خبرة تامة بالتحويلات المرورية ومسار مترو الخط الرابع.",
    responseTime: "10–15 دقيقة في الهرم",
    landmarks: ["أهرامات الجيزة وميدان الرماية", "ميدان مشعل", "شارع العريش التجاري", "محطة وميدان مدكور", "كايرو مول ومول زيزينيا الهرم", "مسرح الزعيم ونصر الدين"],
    streets: ["شارع الأهرام (شارع الهرم)", "شارع ترسا", "طريق المريوطية", "طريق المنصورية", "شارع العريش", "شارع ضياء", "شارع العشرين هرم"],
    localNotes: ["إخلاء سريع للسيارات المعطلة على شارع الهرم لتفادي شل حركة المرور والميكروباصات.", "أوناش مجهزة للتعامل مع المطبات والحفر والتحويلات الإنشائية في محيط نصر الدين والمريوطية.", "إمكانية نقل السيارة مباشرة إلى ورش الهرم وفيصل أو مراكز صيانة طريق مصر إسكندرية الصحراوي وأكتوبر."],
    faqs: [
      {
            "q": "كيف يصل الونش في ظل تحويلات المترو في شارع الهرم؟",
            "a": "سائقونا من أبناء المنطقة وعلى دراية كاملة بكافة الشوارع الجانبية والبديلة مثل فيصل وخاتم المرسلين للوصول إليك في أسرع وقت."
      },
      {
            "q": "هل تنقذون السيارات المعطلة على مطلع كوبري المريوطية؟",
            "a": "نعم، مطلع ومنزل كوبري المريوطية ومحور المنصورية من نقاط تمركز أوناشنا الحيوية."
      }
],
    nearby: ["فيصل", "الطالبية", "المريوطية", "اللبيني", "حدائق الأهرام", "الجيزة", "نصر الدين"]
  },

  "شارع الهرم": {
    tier: 2,
    title: "ونش انقاذ شارع الهرم الجيزة",
    metaDescription: "ونش انقاذ شارع الهرم: محطات نصر الدين، مدكور، حسن محمد، العريش، العشرين، مشعل. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "نوفر تغطية فورية على مدار 24 ساعة لشارع الهرم الرئيسي ومحطاته الشهيرة، لإنقاذ وسحب كافة أنواع السيارات المتعطلة أو المتضررة من الحوادث بأرخص تكلفة.",
    responseTime: "10 دقائق على شارع الهرم",
    landmarks: ["محطة حسن محمد", "محطة المساحة هرم", "محطة العشرين", "فندق مينا هاوس", "سيتي مول الهرم"],
    streets: ["شارع الأهرام الرئيسي", "شارع فاطمة رشدي", "شارع عز الدين عمر", "شارع ترسا (محور محمد أنور السادات)"],
    localNotes: ["استخدام محور ترسا البديل للوصول السريع وتفادي الكثافة المرورية بشارع الهرم.", "توفير خدمات وصلة بطارية وتغيير إطارات وسحب آمن للمركبات."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش لمحطة العريش أو حسن محمد بشارع الهرم؟",
            "a": "أقل من 10 دقائق لتمركز أوناشنا المباشر في شارع الهرم ومحور ترسا."
      }
,
      {
        "q": "هل تغطون شارع الهرم من ميدان الجيزة حتى هرم كفرناهوم؟",
        "a": "نعم، شارع الهرم بكامل امتداده من ميدان الجيزة حتى منطقة أبوالهول وبحيرة قارون مغطى."
      }],
    nearby: ["الهرم", "فيصل", "الطالبية", "نصر الدين", "المريوطية"]
  },

  "فيصل": {
    tier: 1,
    title: "ونش انقاذ فيصل",
    metaDescription: "ونش انقاذ فيصل: محطة حسن محمد، التعاون، شارع العشرين، الطوابق، والمطبعة. أسرع ونش سحب سيارات بخصم 50% 24/7 - اتصل 01044844492.",
    intro: "أسرع خدمة ونش إنقاذ في شارع الملك فيصل ومحاوره التجارية من العشرين وحسن محمد حتى الطوابق وكفر طهرمس بخصم 50% على مدار الساعة.",
    responseTime: "10–15 دقيقة في فيصل",
    landmarks: ["كوبري الملك فيصل ومحطة المترو", "محطة العشرين فيصل", "محطة حسن محمد فيصل", "محطة التعاون ومطاحن فيصل", "ميدان الرماية (نهاية فيصل)"],
    streets: ["شارع الملك فيصل الرئيسي", "شارع العشرين فيصل", "شارع الطالبية فيصل", "شارع المساكن", "طريق المريوطية فيصل", "شارع كفر طهرمس"],
    localNotes: ["أوناش سحب مدمجة فائقة السرعة لسحب السيارة ونقلها قبل حدوث أي تكدس في نهر شارع فيصل التجاري.", "التعامل المحترف مع أعطال الفتيس وأسطوانة الدبرياج الشائعة نتيجة الزحام والتوقف المتكرر في فيصل.", "خدمات تغيير إطارات وتوصيل بنزين وشحن بطارية فورية في الموقع إذا لم تكن السيارة بحاجة لسحب."],
    faqs: [
      {
            "q": "كم دقيقة يستغرق الونش للوصول إلى شارع العشرين أو الطوابق بفيصل؟",
            "a": "يصلك الونش خلال 10 إلى 15 دقيقة لوجود سيارات إنقاذ موزعة على طول امتداد شارع فيصل."
      },
      {
            "q": "هل تسحبون سيارات الحوادث المعطلة في الدوران بفيصل؟",
            "a": "نعم، طاقمنا مدرب على سحب سيارات الحوادث بحرفية تامة دون إحداث أي أضرار بالهيكل أو العفشة."
      }
],
    nearby: ["الهرم", "الطالبية", "نصر الدين", "المريوطية", "الجيزة", "حدائق الأهرام"]
  },

  "شارع فيصل": {
    tier: 2,
    title: "ونش انقاذ شارع الملك فيصل الجيزة",
    metaDescription: "ونش انقاذ شارع الملك فيصل: محطات المساحة، الكوم الأخضر، الوفاء والأمل، العريش فيصل. وصول 10 دقائق بخصم 50% - 01044844492.",
    intro: "تغطية مخصصة ومستمرة لشارع الملك فيصل بالجيزة، تشمل محطة الكوم الأخضر، محطة المساحة، العريش فيصل، ومحيط الدائري بأسرع ونش إنقاذ وأقل سعر.",
    responseTime: "10 دقائق على شارع فيصل",
    landmarks: ["محطة الكوم الأخضر", "موقف ميكروباص فيصل", "سوق فيصل التجاري", "محطة الوفاء والأمل فيصل"],
    streets: ["شارع الملك فيصل", "شارع المستشفى", "شارع الصفا والمروة", "محور المنشية فيصل"],
    localNotes: ["أوناش مدمجة وسريعة الاستجابة لخدمة أصحاب السيارات الملاكي والتاكسي والتجاري.", "توفير حلول طوارئ فورية لشحن البطاريات وتزويد البنزين وتغيير الإطارات."],
    faqs: [
      {
            "q": "كم سعر ونش الإنقاذ في شارع فيصل؟",
            "a": "نوفر أرخص سعر ونش إنقاذ في فيصل مع خصم 50% وبدون أي رسوم خفية. اتصل على 01044844492."
      }
,
      {
        "q": "هل تخدمون التقاطعات الرئيسية على شارع فيصل؟",
        "a": "نعم، جميع التقاطعات الرئيسية على شارع فيصل من الميدان حتى البدرشين مغطاة 24 ساعة."
      }],
    nearby: ["فيصل", "الهرم", "الطالبية", "اللبيني", "المريوطية"]
  },

  "نصر الدين": {
    tier: 2,
    title: "ونش انقاذ نصر الدين الهرم والجيزة",
    metaDescription: "ونش انقاذ نصر الدين: مطلع شارع الهرم، كوبري الجيزة، نفق نصر الدين، محطة مترو الجيزة. وصول 5-10 دقائق - 01044844492.",
    intro: "منطقة نصر الدين هي البوابة الأولى لشارع الهرم من ميدان الجيزة. نوفر أوناش إنقاذ متواجدة عند نفق ومزلقان نصر الدين ومحطة مترو الجيزة لسرعة نجدة أي سيارة متعطلة.",
    responseTime: "5–10 دقائق في نصر الدين",
    landmarks: ["نفق نصر الدين الشهير", "مجمع مسارح نصر الدين", "محطة مترو الجيزة ونصر الدين", "مطلع شارع الهرم من نصر الدين"],
    streets: ["شارع الأهرام (مطلع نصر الدين)", "شارع ترعة الزمر", "شارع ربيع الجيزي", "شارع جمال الدين الأفغاني"],
    localNotes: ["تمركز فوري عند مخرج نفق نصر الدين لتأمين السيارات المتعطلة عند مدخل الهرم.", "سرعة التحرك نحو فيصل أو الهرم أو ميدان الجيزة في دقائق معدودة."],
    faqs: [
      {
            "q": "هل يتوفر ونش عند نفق نصر الدين ومطلع شارع الهرم؟",
            "a": "نعم، أوناشنا متواجدة بنصر الدين وتصلك فور اتصالك على 01044844492."
      }
,
      {
        "q": "ما هي المناطق المجاورة التي يمكنكم الوصول إليها من نصر الدين؟",
        "a": "من نصر الدين نصل خلال 10-15 دقيقة إلى الهرم وفيصل والطالبية والعمرانية والدائري."
      }],
    nearby: ["الهرم", "فيصل", "الجيزة", "ميدان الجيزة", "الطالبية"]
  },

  "الطالبية": {
    tier: 2,
    title: "ونش انقاذ الطالبية هرم وفيصل",
    metaDescription: "ونش انقاذ الطالبية: شارع الطالبية، كوبري الطالبية، ترسا، نزلة الدائري بالطالبية. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "حي الطالبية الرابط بين شارع الهرم وشارع فيصل ومحور ترسا والدائري. نوفر أوناش إنقاذ متمركزة عند كوبري الطالبية لخدمة سريعة لكافة الشوارع السكنية والمحاور المجاورة.",
    responseTime: "10 دقائق في الطالبية",
    landmarks: ["كوبري الطالبية على شارع الهرم", "تقاطع الطالبية مع شارع فيصل", "نزلة الدائري بالطالبية", "مجمع مدارس الطالبية"],
    streets: ["شارع الطالبية العمومي", "محور ترسا (أنور السادات)", "شارع العروبة طالبية", "شارع ضياء", "شارع كفر طهرمس"],
    localNotes: ["تمركز بالقرب من مخرج الطريق الدائري بالطالبية لسرعة التحرك نحو الهرم أو المنيب.", "جاهزية كاملة لإنقاذ السيارات وسحبها في أوقات الذروة بأمان واحترافية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ عند كوبري الطالبية؟",
            "a": "أقل من 10 دقائق لتواجد أوناشنا بالقرب من كوبري الطالبية ومحور ترسا."
      }
,
      {
        "q": "هل تغطون منطقة طالبية الجيزة والمنطقة الصناعية القريبة منها؟",
        "a": "نعم، الطالبية وصولاً إلى صقر قريش والعمرانية وحدائق الأهرام مغطاة بخدماتنا الكاملة."
      }],
    nearby: ["الهرم", "فيصل", "المريوطية", "اللبيني", "نصر الدين", "الطريق الدائري"]
  },

  "اللبيني": {
    tier: 2,
    title: "ونش انقاذ اللبيني هرم وفيصل",
    metaDescription: "ونش انقاذ اللبيني: شارع اللبيني هرم، اللبيني فيصل، نزلة الدائري، مجمع المدارس. وصول 10 دقائق خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "شارع اللبيني من أوسع وأهم المحاور العرضية الرابطة بين الهرم وفيصل والدائري الجنوبي. أوناشنا متمركزة على طول اللبيني لتوفير إنقاذ سريع للمركبات على مدار 24 ساعة.",
    responseTime: "10 دقائق في اللبيني",
    landmarks: ["تقاطع اللبيني مع شارع الهرم", "تقاطع اللبيني مع شارع فيصل", "نزلة الدائري باللبيني", "مجمع مدارس حسام الدين باللبيني"],
    streets: ["شارع اللبيني هرم", "شارع اللبيني فيصل", "الطريق الدائري (مخرج اللبيني)", "شارع المجزر الآلي", "شارع الشيشيني"],
    localNotes: ["تمركز استراتيجي عند نزلة الدائري باللبيني لخدمة سريعة للهرم وفيصل ومحور 26 يوليو الجديد.", "أوناش سطحة مجهزة لنقل السيارات الحديثة والرياضية بأعلى درجات الأمان."],
    faqs: [
      {
            "q": "هل تغطون شارع اللبيني ونزلة الدائري بالهرم؟",
            "a": "نعم، التغطية تشمل شارع اللبيني بالكامل من فيصل حتى الدائري ومحور ترسا."
      }
,
      {
        "q": "كم يستغرق الونش للوصول في حي اللبيني من مركز الجيزة؟",
        "a": "أوناشنا قريبة من مخرج الدائري على الجيزة — نصل إلى اللبيني في 10-15 دقيقة."
      }],
    nearby: ["الهرم", "فيصل", "المريوطية", "حدائق الأهرام", "سقارة", "الطريق الدائري"]
  },

  "المريوطية": {
    tier: 2,
    title: "ونش انقاذ المريوطية هرم وفيصل",
    metaDescription: "ونش انقاذ المريوطية: طريق المريوطية السياحي، كوبري المريوطية، مطلع ومنزل الدائري، محور المنصورية. وصول 10 دقائق - 01044844492.",
    intro: "طريق المريوطية شريان سياحي وحيوي يربط بين وسط الجيزة والطريق الدائري ومناطق سقارة والقرى السياحية. أوناشنا متمركزة عند كوبري المريوطية هرم وفيصل لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10 دقائق في المريوطية",
    landmarks: ["كوبري المريوطية هرم", "كوبري المريوطية فيصل", "تقاطع المريوطية مع الطريق الدائري", "ممشى المريوطية السياحي", "فندق كليوباترا المريوطية"],
    streets: ["طريق ترعة المريوطية السياحي", "طريق المنصورية", "شارع الأهرام (تقاطع المريوطية)", "شارع الملك فيصل", "الطريق الدائري"],
    localNotes: ["تأمين فوري للسيارات على مطلع ومنزل الطريق الدائري بالمريوطية لتفادي الزحام.", "تغطية كاملة للممشى السياحي ومحيط الفنادق والمطاعم الريفية على طريق المريوطية."],
    faqs: [
      {
            "q": "هل يتوفر ونش إنقاذ عند نزلة المريوطية من الطريق الدائري؟",
            "a": "نعم، لدينا ونش متمركز دائماً أسفل كوبري المريوطية الدائري."
      }
,
      {
        "q": "هل تغطون المنطقة الصناعية بالقرب من المريوطية والطريق الدائري؟",
        "a": "نعم، نخدم المريوطية والمنطقة الصناعية ومنطقة حدائق الأهرام ووصلة دهشور بشكل كامل."
      }],
    nearby: ["الهرم", "فيصل", "اللبيني", "حدائق الأهرام", "سقارة", "الطريق الدائري"]
  },

  "حدائق الأهرام": {
    tier: 2,
    title: "ونش انقاذ حدائق الأهرام",
    metaDescription: "ونش انقاذ حدائق الأهرام: بوابات خفرع، خوفو، منقرع، حورس، شارع الجيش، الثروة المعدنية. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "خدمة ونش إنقاذ متخصصة في حدائق الأهرام (هضبة الأهرام) تغطي كافة البوابات (خوفو، خفرع، منقرع، حورس) والمناطق من أ حتى ص بخصم 50% على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة في حدائق الأهرام",
    landmarks: ["بوابة خفرع (البوابة الأولى)", "بوابة خوفو (البوابة الثانية)", "بوابة منقرع (البوابة الثالثة)", "بوابة حورس (البوابة الرابعة)", "شارع الجيش الرئيسي", "شارع الثروة المعدنية"],
    streets: ["شارع الجيش", "شارع الثروة المعدنية", "طريق الفيوم (بوابات الحدائق)", "طريق الواحات (مدخل الحدائق)", "شارع الخزان"],
    localNotes: ["أوناش مجهزة للتعامل مع طبيعة هضبة الأهرام الصخرية وشوارعها المنحدرة ومطباتها الداخلية.", "تمركزات مباشرة أمام بوابات حدائق الأهرام وطريق الواحات لضمان الدخول الفوري دون تأخير.", "سحب السيارات ونقلها لورش حدائق الأهرام أو الهرم أو التوكيلات المعتمدة بطريق الإسكندرية الصحراوي."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش داخل حدائق الأهرام عند بوابة خفرع أو خوفو؟",
            "a": "يصلك الونش خلال 10 إلى 15 دقيقة بحد أقصى داخل أي منطقة بالحدائق."
      },
      {
            "q": "هل الونش يتحمل الصعود في شوارع الهضبة المرتفعة؟",
            "a": "نعم، أوناشنا ذات عزم قوي ومجهزة بفرامل هيدروليكية مخصصة للمنحدرات الصخرية بحدائق الأهرام."
      }
],
    nearby: ["الهرم", "الرماية", "طريق الفيوم", "طريق الواحات", "6 أكتوبر", "الشيخ زايد"]
  },

  "سقارة": {
    tier: 2,
    title: "ونش انقاذ طريق سقارة السياحي",
    metaDescription: "ونش انقاذ طريق سقارة السياحي: أهرامات سقارة، ميت رهينة، المريوطية، البدرشين، دهشور. وصول 15-20 دقيقة خدمة 24 ساعة - 01044844492.",
    intro: "طريق سقارة السياحي يربط بين جنوب الجيزة والمنطقة الأثرية بالبدرشين ودهشور. نوفر أوناش إنقاذ متخصصة لخدمة السيارات السياحية وسيارات الأهالي والزوار على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في سقارة",
    landmarks: ["هرم سقارة المدرج", "متحف إمحوتب", "ميت رهينة عاصمة مصر القديمة", "منطقة أهرامات دهشور", "مدخل البدرشين السياحي"],
    streets: ["طريق سقارة السياحي", "طريق المريوطية الزراعي", "طريق البدرشين - سقارة", "طريق دهشور السياحي"],
    localNotes: ["أوناش مجهزة للتحرك على الطرق الزراعية والسياحية غير المزدحمة بسرعة وأمان.", "توفير خدمات سحب فورية للسيارات العالقة في الرمال أو الحواف الترابية."],
    faqs: [
      {
            "q": "هل تغطون منطقة هرم سقارة وطريق البدرشين السياحي؟",
            "a": "نعم، نغطي طريق سقارة السياحي وميت رهينة ودهشور بالكامل على مدار الساعة."
      }
,
      {
        "q": "هل تخدمون منطقة الطريق الصحراوي والمنطقة الأثرية بسقارة؟",
        "a": "نعم، نغطي طريق سقارة وصول حتى أبوصير ودهشور مع تقديم خدمة السحب الكاملة على الطريق الصحراوي."
      }],
    nearby: ["المريوطية", "اللبيني", "الهرم", "الحوامدية", "البدرشين", "طريق مصر أسيوط"]
  },

  "البحر الأعظم": {
    tier: 2,
    title: "ونش انقاذ شارع البحر الأعظم الجيزة",
    metaDescription: "ونش انقاذ البحر الأعظم: كورنيش النيل بالجيزة، القرية الفرعونية، كوبري الدائري، مخرج المنيب. وصول 10 دقائق خدمة 24 ساعة - 01044844492.",
    intro: "شارع البحر الأعظم كورنيش النيل الرئيسي بالجيزة الذي يربط بين ميدان الجيزة والمنيب والدائري. نوفر أوناش إنقاذ متمركزة عند القرية الفرعونية ومخرج كوبري المنيب لإنقاذ سريع على مدار 24 ساعة.",
    responseTime: "10 دقائق في البحر الأعظم",
    landmarks: ["القرية الفرعونية بالجيزة", "نادي المعلمين بالجيزة", "مطلع كوبري المنيب على الدائري", "فندق أم كلثوم الجيزة (بالقرب)", "نادي التجديف والشرطة"],
    streets: ["شارع البحر الأعظم الرئيسي", "طريق كورنيش النيل الجيزة", "شارع النيل السعيد", "طريق المنيب", "شارع ربيع الجيزي"],
    localNotes: ["تأمين الحوادث والأعطال السريعة على كورنيش البحر الأعظم وتفادي تعطل الحركة المرورية.", "أوناش سطحة مجهزة لخدمة نوادي وفنادق ومطاعم البحر الأعظم النيلية."],
    faqs: [
      {
            "q": "كم يستغرق وصول ونش الإنقاذ أمام القرية الفرعونية بالبحر الأعظم؟",
            "a": "يصل الونش خلال أقل من 10 دقائق من نقطة تمركزنا عند مطلع كوبري المنيب."
      }
,
      {
        "q": "كيف تصلون بسرعة في شارع البحر الأعظم وسط الزحام؟",
        "a": "نستخدم الشوارع الجانبية المتوازية في المهندسين والدقي — نضمن وصول سريع لأي حادث على البحر الأعظم."
      }],
    nearby: ["الجيزة", "المنيب", "ميدان الجيزة", "الدقي", "المعادي (عبر الدائري)", "شارع مراد"]
  },

  "المنيب": {
    tier: 2,
    title: "ونش انقاذ المنيب",
    metaDescription: "ونش انقاذ المنيب: محطة مترو المنيب، موقف المنيب الإقليمي، كوبري المنيب، شارع البحر الأعظم، ميدان المنيب. وصول 10 دقائق - 01044844492.",
    intro: "ونش إنقاذ المنيب ومحيط الموقف الإقليمي ومترو المنيب ومطلع الطريق الدائري وطريق الصعيد الزراعي؛ نصلك في أقل من 10 دقائق بأوناش سطحة وروافع ثقيلة.",
    responseTime: "10 دقائق في المنيب",
    landmarks: ["محطة مترو المنيب", "موقف سيارات الأقاليم بالمنيب", "كوبري المنيب المعلق على النيل", "ميدان المنيب الرئيسي", "مستشفى المنيب التخصصي"],
    streets: ["طريق الصعيد الحر (مدخل المنيب)", "شارع البحر الأعظم", "شارع ربيع الجيزي", "طريق مصر أسيوط الزراعي", "محور ترعة الزمر"],
    localNotes: ["تمركز مباشر عند مطلع ومنزل دائري المنيب اتجاه المعادي والتجمع وأكتوبر لنجدة المسافرين.", "جاهزية كاملة لإنقاذ سيارات الملاكي وسيارات النقل والميكروباص بمحيط الموقف الإقليمي.", "سرعة نقل السيارات المعطلة لمجمعات ورش صقر قريش بالمعادي أو ورش شارع البحر الأعظم والجيزة."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش عند موقف المنيب أو محطة المترو؟",
            "a": "نصلك في أقل من 8 دقائق لتواجد ونش متمركز بصورة دائمة عند مدخل موقف المنيب والدائري."
      },
      {
            "q": "هل تسحبون سيارات السفر المعطلة على أول طريق الصعيد الزراعي بالمنيب؟",
            "a": "نعم، بداية طريق الصعيد الزراعي ومحور المنيب ضمن نطاق تغطيتنا السريعة على مدار 24 ساعة."
      }
],
    nearby: ["البحر الأعظم", "الجيزة", "الطريق الدائري", "المعادي", "الحوامدية", "الهرم"]
  },

  "الوراق": {
    tier: 2,
    title: "ونش انقاذ الوراق",
    metaDescription: "ونش انقاذ الوراق: كورنيش النيل بالوراق، كوبري تحيا مصر (محور روض الفرج)، شارع القومية، ميدان طناش. وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ الوراق وجزيرة محمد وكورنيش الوراق ومطلع الدائري؛ أوناش سريعة ومجهزة لنقل سيارات الملاكي وسيارات النقل الخفيف في 10 إلى 15 دقيقة.",
    responseTime: "10–15 دقيقة في الوراق",
    landmarks: ["كوبري تحيا مصر (محور روض الفرج)", "ميدان الوراق الرئيسي", "ميدان طناش", "مستشفى الوراق المركزي", "مرسى جزيرة الوراق"],
    streets: ["شارع كورنيش النيل الوراق", "شارع القومية العربية", "محور روض الفرج الحر", "شارع ترعة السواحل", "شارع الغاز"],
    localNotes: ["تمركز حيوي عند مطلع ومنزل الطريق الدائري بالوراق لتأمين سيارات المسافرين وسكان المنطقة.", "أوناش قادرة على المناورة في شوارع الوراق التجارية وتفادي زحام المعديات والمواقف الشعبية.", "نقل سريع لسيارات الأعطال إلى ورش صيانة شبرا الخيمة أو إمبابة أو الجيزة."],
    faqs: [
      {
            "q": "هل الونش متاح بالقرب من مطلع الدائري بالوراق؟",
            "a": "نعم، لدينا نقطة ارتكاز دائمة عند مطلع دائري الوراق لسرعة التدخل على الدائري والكورنيش."
      },
      {
            "q": "لو العربية عطلانة عند كورنيش الوراق كم يستغرق الوصول؟",
            "a": "نصلك خلال 10 دقائق بحد أقصى لتواجد سياراتنا الميدانية على امتداد الكورنيش."
      }
],
    nearby: ["إمبابة", "محور روض الفرج", "شبرا", "الدائري", "أوسيم"]
  },

  "إمبابة": {
    tier: 2,
    title: "ونش انقاذ إمبابة",
    metaDescription: "ونش انقاذ إمبابة: ميدان الكيت كات، كورنيش النيل، شارع الوحدة، محطة مترو إمبابة، كوبري إمبابة. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "ونش إنقاذ إمبابة وميدان الكيت كات وشارع الوحدة والقومية العربية وكورنيش النيل؛ أوناش شوكة وسحب مدمجة قادرة على دخول أضيق الشوارع الشعبية في 10 دقائق.",
    responseTime: "10 دقائق في إمبابة",
    landmarks: ["ميدان الكيت كات", "محطة مترو إمبابة والكيت كات", "كوبري إمبابة الحديدي", "مستشفى إمبابة العام", "معهد ناصر (بالقرب)", "شارع الوحدة التجاري"],
    streets: ["شارع الوحدة", "شارع السودان (شمال)", "شارع النيل إمبابة", "شارع ترعة الزمر", "شارع القومية العربية"],
    localNotes: ["أوناش شوكة مدمجة (Wheel-Lift) مصممة خصيصاً للمناورة في شوارع إمبابة الشعبية والأسواق التجارية المزدحمة.", "سرعة رفع السيارة لتفادي شل حركة السير بمحيط محطة مترو الكيت كات ومحور 26 يوليو الجديد.", "إمكانية نقل السيارة مباشرة لورش إمبابة والوراق أو مراكز صيانة المهندسين المجاورة."],
    faqs: [
      {
            "q": "هل يستطيع الونش الدخول في شوارع إمبابة الضيقة مثل شارع الوحدة؟",
            "a": "نعم، أوناشنا مدمجة ومخصصة للشوارع السكنية المزدحمة وتلتف في أضيق الحارات بسهولة تامة."
      },
      {
            "q": "كم تكلفة سحب سيارة داخل إمبابة؟",
            "a": "التكلفة تبدأ من 250 ج.م مع تطبيق خصم 50%، ويتم تأكيد السعر هاتفياً قبل انطلاق الونش."
      }
],
    nearby: ["الوراق", "العجوزة", "الزمالك", "المهندسين", "شبرا مصر", "ميدان الكيت كات"]
  },

  "6 أكتوبر": {
    tier: 1,
    title: "ونش انقاذ 6 أكتوبر",
    metaDescription: "ونش انقاذ 6 أكتوبر: ميدان الحصري، مول العرب، مول مصر، المحور المركزي، طريق الواحات، المنطقة الصناعية. سطحة هيدروليك تصلك في 10-12 دقيقة 24/7 بخصم 50% - اتصل 01044844492.",
    intro: "تغطية شاملة وميدانية لكافة أحياء ومحاور مدينة 6 أكتوبر: ميدان الحصري، المحور المركزي، المنطقة الصناعية (1-6)، مول مصر، مول العرب، ميدان جهينة، وطريق الواحات بأحدث أسطول أوناش إنقاذ سطحة وروافع ثقيلة على مدار 24 ساعة.",
    responseTime: "10–12 دقيقة في 6 أكتوبر",
    dispatchPoints: [
      "ميدان الحصري وجامعة 6 أكتوبر والمحور المركزي (الاستجابة: 8–10 دقائق)",
      "ميدان جهينة ومول العرب ومحور 26 يوليو (الاستجابة: 8–10 دقائق)",
      "طريق الواحات ومول مصر ومدينة الإنتاج الإعلامي (الاستجابة: 10–12 دقيقة)",
      "المنطقة الصناعية ومحور وصلة دهشور (الاستجابة: 12–15 دقيقة)"
    ],
    landmarks: [
      "ميدان الحصري وجامع الحصري",
      "مول العرب Mall of Arabia",
      "مول مصر Mall of Egypt",
      "جامعة 6 أكتوبر O6U",
      "جامعة مصر للعلوم والتكنولوجيا MUST",
      "جامعة MSA",
      "مستشفى دار الفؤاد ومستشفى سعاد كفافي",
      "المنطقة الصناعية (المراحل من 1 إلى 6)",
      "القرية الذكية Smart Village",
      "مدينة الإنتاج الإعلامي وميدان جهينة"
    ],
    streets: [
      "المحور المركزي 6 أكتوبر",
      "طريق الواحات",
      "محور 26 يوليو",
      "طريق وصلة دهشور",
      "طريق مصر إسكندرية الصحراوي",
      "محور جمال عبد الناصر أكتوبر",
      "محور الكفراوي",
      "طريق البترول والمنطقة الصناعية",
      "محور الضبعة ومداخل أكتوبر الجديدة"
    ],
    localNotes: [
      "أوناش متنوعة بين السطحات الهيدروليكية للسيارات الملاكي وأوناش الانتشال الثقيلة لنقل سيارات النقل والجامبو والمعدات بالمنطقة الصناعية.",
      "تغطية سريعة لحالات الأعطال على طريق الواحات ومحور 26 يوليو ووصلة دهشور ومحيط حدائق أكتوبر والشيخ زايد.",
      "تنسيق فوري لدخول كمبوندات 6 أكتوبر السكنية (بالم هيلز، ماونتن فيو، بادية، بيفرلي هيلز) مع أطقم الأمن.",
      "نقل السيارات لمراكز الخدمة والتوكيلات المعتمدة بالمنطقة الصناعية أو العودة بها للقاهرة والجيزة بأقل تكلفة."
    ],
    faqs: [
      {
        "q": "كم يستغرق وصول ونش الإنقاذ عند ميدان الحصري أو المحور المركزي بأكتوبر؟",
        "a": "يصلك الونش في أقل من 8 إلى 10 دقائق لتواجد نقطة تمركز ثابتة بالقرب من ميدان الحصري ومحور جمال عبد الناصر."
      },
      {
        "q": "هل يتوفر ونش لإنقاذ السيارات على طريق الواحات أو محور 26 يوليو؟",
        "a": "نعم، أوناشنا متمركزة على مداخل ومخارج طريق الواحات ومحور 26 يوليو ووصلة دهشور لتأمين وسحب السيارات المعطلة في أسرع وقت."
      },
      {
        "q": "هل تنقلون سيارات النقل والمعدات المعطلة بالمنطقة الصناعية بأكتوبر؟",
        "a": "نعم، نمتلك أوناش انتشال وروافع ثقيلة بحمولات حتى 10 أطنان لنقل السيارات التجارية والنقل الخفيف والمعدات بكافة مراحل المنطقة الصناعية."
      },
      {
        "q": "هل تستطيع أوناشكم الدخول إلى كمبوندات 6 أكتوبر؟",
        "a": "نعم، سائقونا يحملون تراخيص وهويات رسمية وأوناشنا مرخصة لتسهيل وسرعة الدخول عبر بوابات أمن الكمبوندات في دقائق."
      },
      {
        "q": "هل يمكن نقل السيارة من 6 أكتوبر إلى توكيلات الصيانة بالقاهرة أو الجيزة؟",
        "a": "نعم، نوفر خدمة نقل مباشرة لأي توكيل أو مركز صيانة تختاره في القاهرة أو الجيزة أو المحافظات بتسعيرة ثابتة ومخفضة بخصم 50%."
      }
    ],
    nearby: ["الشيخ زايد", "حدائق أكتوبر", "وصلة دهشور", "طريق الواحات", "طريق إسكندرية الصحراوي", "الحي المتميز"]
  },

  "حدائق أكتوبر": {
    tier: 2,
    title: "ونش انقاذ حدائق أكتوبر",
    metaDescription: "ونش انقاذ حدائق أكتوبر: طريق زويل، كمبوندات دجلة بالمز، الفردوس، كنز، طريق الواحات، الإسكان الاجتماعي. وصول 15-20 دقيقة - 01044844492.",
    intro: "تغطية متميزة لإنقاذ وسحب السيارات في حدائق أكتوبر، نخدم مدينة زويل للعلوم والتكنولوجيا، كمبوند دجلة بالمز، حي الأشجار، كمبوند الفردوس، ومحور زويل على مدار 24 ساعة.",
    responseTime: "15–20 دقيقة في حدائق أكتوبر",
    landmarks: ["مدينة زويل للعلوم والتكنولوجيا", "حي الأشجار", "كمبوند دجلة بالمز Degla Palms", "كمبوند الفردوس", "سوق الجملة بحدائق أكتوبر", "نادي الزمالك بأكتوبر"],
    streets: ["طريق زويل (طريق حدائق أكتوبر الرئيسي)", "طريق الواحات", "طريق الفيوم (مدخل حدائق أكتوبر)", "طريق النايل سات", "محور صبحي عبد الحكيم"],
    localNotes: ["أوناش متواجدة عند مدخل طريق زويل وكمبوند دجلة بالمز لسرعة الوصول للمجمعات السكنية.", "جاهزية لسحب السيارات من الطرق الترابية ومداخل الكمبوندات الحديثة."],
    faqs: [
      {
            "q": "هل تغطون كمبوند دجلة بالمز ومدينة زويل بحدائق أكتوبر؟",
            "a": "نعم، نغطي دجلة بالمز ومدينة زويل وكافة كمبوندات حدائق أكتوبر على مدار 24 ساعة."
      }
,
      {
        "q": "هل تخدمون منطقة حدائق الأهرام القريبة من حدائق أكتوبر؟",
        "a": "نعم، نغطي حدائق أكتوبر ومنطقة الجمعة وكمبوندات درة أكتوبر وكل ما يتفرع من الدائري."
      }],
    nearby: ["6 أكتوبر", "الشيخ زايد", "طريق الواحات", "حدائق الأهرام", "طريق الفيوم"]
  },

  "الشيخ زايد": {
    tier: 1,
    title: "ونش انقاذ الشيخ زايد",
    metaDescription: "ونش انقاذ الشيخ زايد: أركان بلازا، كابيتال بيزنس بارك، هايبر وان، بيفرلي هيلز، الحي المتميز، وصلة دهشور. وصول 10-15 دقيقة - 01044844492.",
    intro: "ونش إنقاذ الشيخ زايد لخدمة أرقى الأحياء والكمبوندات: هايبر وان، أركان، بيفرلي هيلز، كابيتال بيزنس بارك، ومحور 26 يوليو؛ وصول خلال 10 إلى 15 دقيقة بسطحات هيدروليكية حديثة.",
    responseTime: "10–15 دقيقة في الشيخ زايد",
    landmarks: ["أركان بلازا Arkan Plaza", "كابيتال بيزنس بارك Capital Business Park", "هايبر وان Hyper One", "كمبوند بيفرلي هيلز Beverly Hills", "مول زايد سنترال", "مستشفى الشيخ زايد التخصصي", "أمريكانا بلازا"],
    streets: ["محور 26 يوليو (مدخل زايد)", "طريق النزهة بالشيخ زايد", "شارع البستان", "طريق وصلة دهشور", "طريق إسكندرية الصحراوي (مدخل زايد)", "محور الشباب زايد"],
    localNotes: ["أوناش سطحة هيدروليكية كاملة بزاوية صفرية مخصصة للسيارات الفارهة والسيارات الرياضية والكهربائية (EV) بزايد.", "تصاريح دخول لكافة بوابات الكمبوندات والمجمعات السكنية المغلقة بالشيخ زايد.", "نقل سريع وآمن لسيارات الأعطال على محور 26 يوليو ووصلة دهشور وطريق الإسكندرية الصحراوي."],
    faqs: [
      {
            "q": "هل يستطيع الونش دخول بوابات كمبوند بيفرلي هيلز أو سوديك بالشيخ زايد؟",
            "a": "نعم، جميع سياراتنا وسائقينا يحملون أوراقاً وتراخيص معتمدة وندير التنسيق مع أمن البوابات فور اتصالك."
      },
      {
            "q": "هل الونش مجهز لنقل سيارات الدفع الرباعي والسيارات المنخفضة بزايد؟",
            "a": "بالتأكيد، نستخدم سطحات هيدروليكية كاملة تلامس الأرض تماماً لمنع احتكاك الصدادات وحماية أنظمة التعليق."
      }
],
    nearby: ["6 أكتوبر", "وصلة دهشور", "الحي المتميز", "بيفرلي هيلز", "أركان بلازا", "محور 26 يوليو"]
  },

  "وصلة دهشور": {
    tier: 2,
    title: "ونش انقاذ وصلة دهشور الشيخ زايد وأكتوبر",
    metaDescription: "ونش انقاذ وصلة دهشور: من طريق إسكندرية الصحراوي وبوابة زايد حتى طريق الواحات ومول العرب. وصول 10-15 دقيقة - 01044844492.",
    intro: "طريق وصلة دهشور هو المحور الرابط السريع بين طريق القاهرة - الإسكندرية الصحراوي ومدينة الشيخ زايد ومول العرب وطريق الواحات. أوناشنا متمركزة على الوصلة لإنقاذ فوري على مدار 24 ساعة.",
    responseTime: "10–15 دقيقة على وصلة دهشور",
    landmarks: ["بوابة زايد 2000 على وصلة دهشور", "مدخل بيفرلي هيلز الغربي", "ميدان جهينة", "مول العرب (مخرج دهشور)", "نادي الأهلي بالشيخ زايد"],
    streets: ["طريق وصلة دهشور الرئيسي", "محور 26 يوليو", "طريق الواحات", "طريق إسكندرية الصحراوي", "محور البوليفارد"],
    localNotes: ["تأمين فوري للسيارات المسرعة على وصلة دهشور بأقماع تحذيرية وإضاءات ليلية ساطعة.", "سرعة التحرك نحو كمبوندات غرب زايد ومول العرب وبوابات طريق إسكندرية الصحراوي."],
    faqs: [
      {
            "q": "كم يستغرق وصول الونش على طريق وصلة دهشور أمام بيفرلي هيلز؟",
            "a": "يصل الونش خلال أقل من 10 دقائق لتواجدنا الدائم على محور وصلة دهشور."
      }
,
      {
        "q": "هل يوجد زمن مختلف للوصول على وصلة دهشور مقارنة بشارع فيصل؟",
        "a": "وصلة دهشور طريق سريع — أوناشنا تصل في 10-20 دقيقة وهي أسرع من الوصول عبر شارع فيصل في أوقات الذروة."
      }],
    nearby: ["الشيخ زايد", "6 أكتوبر", "بيفرلي هيلز", "مول العرب", "طريق إسكندرية الصحراوي"]
  },

  "الحي المتميز": {
    tier: 2,
    title: "ونش انقاذ الحي المتميز 6 أكتوبر والشيخ زايد",
    metaDescription: "ونش انقاذ الحي المتميز: مستشفى دار الفؤاد، جامعة مصر للعلوم والتكنولوجيا MUST، محور 26 يوليو. وصول 10 دقائق - 01044844492.",
    intro: "الحي المتميز من أهدى وأقدم أحياء 6 أكتوبر الراقية على محور 26 يوليو. نخدم محيط مستشفى دار الفؤاد، جامعة مصر للعلوم والتكنولوجيا (MUST)، وفندق موفنبيك بأحدث أوناش السحب السريعة.",
    responseTime: "10 دقائق في الحي المتميز",
    landmarks: ["مستشفى دار الفؤاد", "جامعة مصر للعلوم والتكنولوجيا MUST", "فندق موفنبيك أكتوبر", "ميدان النجدة", "نادي وادي دجلة أكتوبر"],
    streets: ["محور 26 يوليو (واجهة المتميز)", "شارع عبد المنعم رياض بالمتميز", "شارع النزهة المتميز", "شارع عبد المنعم رياض", "طريق الواحات"],
    localNotes: ["خدمة فورية لحالات الطوارئ أمام مستشفى دار الفؤاد وجامعة MUST.", "أوناش هيدروليكية لنقل السيارات الفاخرة بدون أي احتكاك."],
    faqs: [
      {
            "q": "هل تغطون محيط مستشفى دار الفؤاد وجامعة مصر MUST بالحي المتميز؟",
            "a": "نعم، أوناشنا متمركزة مباشرة على محور 26 يوليو أمام مستشفى دار الفؤاد."
      }
,
      {
        "q": "كم يستغرق وصول الونش للحي المتميز في 6 أكتوبر؟",
        "a": "الحي المتميز قريب من محور 26 يوليو — وصولنا في 10-20 دقيقة من نقطة التمركز القريبة."
      }],
    nearby: ["6 أكتوبر", "الشيخ زايد", "محور 26 يوليو", "وصلة دهشور", "أركان بلازا"]
  },

  "بيفرلي هيلز": {
    tier: 2,
    title: "ونش انقاذ كمبوند بيفرلي هيلز الشيخ زايد",
    metaDescription: "ونش انقاذ بيفرلي هيلز: بوابات 1 إلى 5، ويست تاون، المدرسة البريطانية، كازا، وصلة دهشور. وصول 10-15 دقيقة بخصم 50% - 01044844492.",
    intro: "كمبوند بيفرلي هيلز وسوديك ويست من أكبر المجمعات السكنية الراقية بالشيخ زايد. نوفر أوناش إنقاذ مرخصة للدخول الفوري عبر كافة البوابات لخدمة الفيلات والشقق والنوادي بأعلى معايير الأمان.",
    responseTime: "10–15 دقيقة في بيفرلي هيلز",
    landmarks: ["سوديك ويست تاون Sodic Westown", "نادي بيفرلي هيلز الرياضي", "المدرسة البريطانية بالشيخ زايد", "ذا ستريب مول The Strip Mall", "بوابات 1 و 2 و 3 بيفرلي هيلز"],
    streets: ["طريق وصلة دهشور", "شارع بيفرلي هيلز الرئيسي", "طريق البوليفارد", "طريق إسكندرية الصحراوي (مدخل سوديك)"],
    localNotes: ["تنسيق مسبق وسلس مع أمن بوابات بيفرلي هيلز وسوديك ويست.", "أوناش حديثة مزودة بفرامات مطاطية وسلاسل قماشية لحماية إطارات وجنوط السيارات الفارهة."],
    faqs: [
      {
            "q": "كيف يتم التنسيق لدخول ونش الإنقاذ إلى بيفرلي هيلز؟",
            "a": "يقوم سائق الونش بإبراز تصريح المهمة والتنسيق مع أمن البوابة برقم العميل لسرعة الدخول."
      }
,
      {
        "q": "هل تدخل الأوناش إلى بيفرلي هيلز وتتنقل داخل الكمبوند؟",
        "a": "نعم، ندخل بيفرلي هيلز بالتنسيق مع البوابة — الأوناش المدمجة الخاصة بنا تناسب الشوارع الداخلية."
      }],
    nearby: ["الشيخ زايد", "وصلة دهشور", "6 أكتوبر", "أركان بلازا", "الحي المتميز"]
  },

  "أركان بلازا": {
    tier: 2,
    title: "ونش انقاذ أركان بلازا الشيخ زايد",
    metaDescription: "ونش انقاذ أركان بلازا: مدخل زايد 2000، كابيتال بيزنس بارك، شارع البستان، محور 26 يوليو. وصول 5-10 دقائق خدمة 24/7 - 01044844492.",
    intro: "مجمع أركان بلازا هو القلب التجاري والإداري النابض لمدينة الشيخ زايد. أوناش إنقاذ محمد بحر متمركزة بجوار أركان وكابيتال بارك لتقديم أسرع خدمة سحب سيارات في قلب زايد.",
    responseTime: "5–10 دقائق في أركان بلازا",
    landmarks: ["أركان بلازا Arkan Plaza 1 & 2", "كابيتال بيزنس بارك Capital Business Park", "كمبوند زايد 2000", "ميدان أركان", "مستشفى روفيدة للولادة"],
    streets: ["شارع البستان الرئيسي", "محور 26 يوليو", "طريق النزهة زايد", "شارع المستقبل"],
    localNotes: ["أوناش هيدروليكية منخفضة قادرة على النزول والدخول لجراجات أركان بلازا السفلية.", "تأمين فوري للسيارات في مواقف أركان والشركات المجاورة طوال 24 ساعة."],
    faqs: [
      {
            "q": "هل ونش الإنقاذ قادر على سحب سيارة معطلة داخل جراج أركان بلازا السفلي؟",
            "a": "نعم، نوفر أوناشاً مخصصة بارتفاعات مدروسة للدخول لجراجات المولات تحت الأرض وسحب السيارة بأمان."
      }
,
      {
        "q": "هل تخدمون موقف سيارات أركان بلازا والمنطقة التجارية المحيطة؟",
        "a": "نعم، موقف أركان بلازا وكل مواقف المول التجاري مغطاة بأوناشنا المدمجة المخصصة للجراجات."
      }],
    nearby: ["الشيخ زايد", "هايبر وان", "بيفرلي هيلز", "الحي المتميز", "محور 26 يوليو"]
  }
};
